import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { SessionService } from '../../../core/services/session.service';
import { ConfigService } from '../../../core/services/config.service';
import { RequestService } from '../../../core/services/request.service';

@Injectable()
export class ProfileService {

    constructor(
        private http: Http,
        private sessionService: SessionService,
        private requestService: RequestService,
        private configService: ConfigService
    ) {}

    getProfile(): Observable<any> {
        let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.profile.details.api;
        return this.requestService.get(url);
    }

    editProfile(details: any): Observable<any> {
        let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.profile.edit.api;
        return this.requestService.post(url, details)
    }

    getLanguagesDictionary(): Observable<any> {
        let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').solar.system.language.api;
        return this.requestService.get(url);
    }

    getTimezonesDictionary(): Observable<any> {
        let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').solar.system.timezone.api;
        return this.requestService.get(url);
    }

    requestDataDeletion(details: any): Observable<any> {
      let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.profile.requestDataDeletion.api;
      return this.requestService.post(url, details)
    }

    loadPrivacyPolicy(): Observable<any> {
      let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').hamlet.detailsBySearchKey.api+
      '/leapest-privacy-policy-for-end-users-on-the-branded-portal';
      return this.requestService.get(url)
    }

    updateConsent(privacyPolicyLastUpdatedDate: any): Observable<any>{
      let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.profile.updateGdprConsent.api;
      return this.requestService.post(url, {privacyPolicyLastUpdatedDate: privacyPolicyLastUpdatedDate})
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/profile/profile.service.ts